<template>
  <div class="break-time-editor">
    <div class="break-time-add-form">
      <input
        v-model="addForm.start"
        type="text"
        placeholder="00:00"
      >
      <span class="dash">-</span>
      <input
        v-model="addForm.end"
        type="text"
        placeholder="00:00"
      >
      <div
        class="button"
        @click="handleClickAddButton"
      >
        추가
      </div>
    </div>

    <div
      v-for="(breakTime, itemIndex) in value"
      class="break-time-item"
    >
      <span class="time">{{ breakTime.start }}</span>
      <span class="dash">-</span>
      <span class="time">{{ breakTime.end }}</span>
      <div
        class="button"
        @click="handleClickDeleteButton(itemIndex)"
      >
        삭제
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import HourMinutes from "./hourMinutes";

export default {
	name: "BreakTimeEditor",
	props: {
		value: {
			type: Array,
			default() {
				return [];
			},
		},
		courseStartEndTimes: {
			type: Array,
		},
	},
	data() {
		return {
			addForm: {
				start: "",
				end: "",
			},
		};
	},
	computed: {
		courseStartTime() {
			return _.min(this.courseStartEndTimes);
		},
		courseEndTime() {
			return _.max(this.courseStartEndTimes);
		},
	},
	mounted() {},
	methods: {
		handleClickAddButton() {
			try {
				this.addForm.start = this.validateTime(this.addForm.start);
				this.addForm.end = this.validateTime(this.addForm.end);
			} catch (err) {
				return this.$message(err.message);
			}

			if (
				HourMinutes.dateToMinutes(this.addForm.start) >
				HourMinutes.dateToMinutes(this.addForm.end)
			) {
				return this.$message("종료 시간이 시작 시간보다 앞설 수 없습니다.");
			}

			const newBreakTimes = _.concat(this.value, _.cloneDeep(this.addForm));
			this.$emit("input", newBreakTimes);
			this.$emit("change", newBreakTimes);
			this.addForm.start = "";
			this.addForm.end = "";
		},
		handleClickDeleteButton(deleteItemIndex) {
			const newBreakTimes = this.value.filter(
				(breakTime, index) => index !== deleteItemIndex
			);
			this.$emit("input", newBreakTimes);
			this.$emit("change", newBreakTimes);
		},
		validateTime(time) {
			if (!time.includes(":")) {
				throw new Error("올바른 시간 형식이 아닙니다.");
			}

			let splitedTime = time.split(":");
			let hour = parseInt(splitedTime[0]);
			let minutes = parseInt(splitedTime[1]);
			const hourMinutes = hour * 60 + minutes;

			if (isNaN(hour) || isNaN(minutes)) {
				throw new Error("올바른 시간 형식이 아닙니다.");
			}

			if (hour > 24 || hour < 0) {
				throw new Error("올바른 시간 형식이 아닙니다.");
			}

			if (minutes > 59 || minutes < 0) {
				throw new Error("올바른 시간 형식이 아닙니다.");
			}

			if (hourMinutes < this.courseStartTime) {
				throw new Error("첫 수업 이전 시간을 입력하셨습니다.");
			}

			if (hourMinutes > this.courseEndTime) {
				throw new Error("마지막 수업 이후 시간을 입력하셨습니다.");
			}

			return `${hour >= 10 ? hour : `0${hour}`}:${
				minutes >= 10 ? minutes : `0${minutes}`
			}`;
		},
	},
};
</script>

<style lang="scss">
span.dash {
	display: inline-block;
	width: 8px;
	font-size: 17px;
	text-align: center;
	color: #4a4a4a;
}

.break-time-add-form {
	height: 40px;
	border-radius: 6px;
	border: 1px solid #d3d3d3;
	padding: 9px;
	margin-bottom: 10px;

	input {
		width: 50px;
		height: 20px;
		border: 0px solid #d3d3d3;
		border-radius: 6px;
		text-align: center;

		font-size: 15px;
		letter-spacing: -0.8px;
		color: #4a4a4a;

		&::placeholder {
			color: #d3d3d3;
		}
	}

	.button {
		width: 50px;
		height: 20px;
		line-height: 20px;
		color: #4a4a4a;
		border: 0px solid #d3d3d3;
		background: transparent;
		border-radius: 6px;
		text-align: center;
		float: right;
		cursor: pointer;

		&:hover {
			text-decoration: underline;
		}
	}
}

.break-time-item {
	height: 40px;
	border-radius: 6px;
	border: none;
	padding: 9px;
	background-color: #f0f0f0;
	margin-bottom: 5px;

	.time {
		display: inline-block;
		width: 50px;
		line-height: 20px;
		height: 20px;
		text-align: center;
		font-size: 15px;
		letter-spacing: -0.8px;
		color: #4a4a4a;
	}

	.button {
		width: 50px;
		line-height: 20px;
		height: 20px;
		color: #4a4a4a;
		border: 0px solid #d3d3d3;
		background: transparent;
		border-radius: 6px;
		text-align: center;
		float: right;
		cursor: pointer;

		&:hover {
			/*background-color: #e6e6e6;*/
			color: #dc1e00;
			text-decoration: underline;
		}
	}
}
</style>
